import "./SliderComponent.scss";
const Slider = ({ value, max, onChange }) => {
    return (
        <input
            disabled={!max}
            type="range"
            value={value || 0}
            min="0"
            max={max || 0}
            className="slider"
            onChange={e => {
                onChange(+e.target.value);
            }}
        />
    );
};

export default Slider;
